/**
 * Utility functions for handling referral codes
 */

/**
 * Extract referrer code from URL parameters
 * @returns referrer code if found, null otherwise
 */
export const getReferrerCodeFromURL = (): string | null => {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const referrerCode = urlParams.get("r");

    // Validate referrer code (should be 6 characters, alphanumeric)
    if (referrerCode && /^[a-f0-9]{6}$/i.test(referrerCode)) {
      return referrerCode.toLowerCase();
    }

    return null;
  } catch (error) {
    console.error("Error extracting referrer code from URL:", error);
    return null;
  }
};

/**
 * Store referrer code in session storage for later use
 * @param code referrer code to store
 */
export const storeReferrerCode = (code: string): void => {
  try {
    sessionStorage.setItem("death-fun-referrer-code", code);
  } catch (error) {
    console.error("Error storing referrer code:", error);
  }
};

/**
 * Get stored referrer code from session storage
 * @returns stored referrer code or null
 */
export const getStoredReferrerCode = (): string | null => {
  try {
    return sessionStorage.getItem("death-fun-referrer-code");
  } catch (error) {
    console.error("Error getting stored referrer code:", error);
    return null;
  }
};

/**
 * Clear stored referrer code
 */
export const clearStoredReferrerCode = (): void => {
  try {
    sessionStorage.removeItem("death-fun-referrer-code");
  } catch (error) {
    console.error("Error clearing stored referrer code:", error);
  }
};
